import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createRefundPaymentMutation } from "@/app/Refunds/GraphQL/refundMutations";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { DateTimeInput } from "@/lib/Components/Form/Inputs/DateTimeInput";
import { SelectInput } from "@/lib/Components/Form/Inputs/SelectInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import {
  Currency,
  RefundPaymentMethod,
  CreateRefundPaymentInput,
} from "@/gql/graphql";
import { toDateTimeString } from "@/lib/Formatters/toDateTimeString";

const methodOptions = [
  {
    label: "Payment Method",
    options: [
      { label: "Direct Deposit", value: RefundPaymentMethod.DirectDeposit },
      { label: "PayPal", value: RefundPaymentMethod.Paypal },
    ],
  },
];

export function AddRefundPaymentDialog({
  refundId,
  currency,
}: {
  refundId: string;
  currency: Currency;
}) {
  const { mutateAsync } = useGqlMutation(createRefundPaymentMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title="Add Refund Payment">
      <GenericForm<CreateRefundPaymentInput>
        initialValues={{
          refund_form_id: refundId,
          method: RefundPaymentMethod.DirectDeposit,
          amount: 0,
          currency: currency,
          refunded_at: toDateTimeString(new Date()),
          transaction_number: null,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            input: values,
          });

          close();
        }}
      >
        <SelectInput
          name="method"
          label="Payment Method"
          options={methodOptions}
        />
        <CurrencyInput name="amount" label="Amount" currency={currency} />
        <DateTimeInput name="refunded_at" label="Refunded At" />
        <TextInput
          name="transaction_number"
          label="Transaction Number"
          className="col-span-full"
        />
        <DialogSubmitButton text="Add Payment" />
      </GenericForm>
    </BaseDialog>
  );
}
